import { callApi } from '@local_modules/generic/fetch.js'
import * as mAccount from './account.js'

// Use storage in the module
const moduleStore = {}
moduleStore.userData = null

export function userData () {
  return moduleStore.userData
}

export function isUserLoggedIn () {
  // console.log('isUserLoggedIn?', moduleStore.userData)
  if (moduleStore.userData) {
    return true
  } else {
    return false
  }
}

export async function loadUser () {
  // console.log('loadUser')
  const urlApi = ['/auth', 'profile'].join('/')

  const response = await callApi(urlApi)
  console.log('response', response)
  moduleStore.userData = response
  return 'loadUser done'
}

export function showRestrictedPage () {
  mAccount.showUnauthorisedAccount({ isUserLoggedIn: isUserLoggedIn() })
}

/**
 * Ensure (1) the account is public or (2) the user (2.1) is logged in and (2.2) has access to the account
 * @param {Object} [options]
 * @param {Boolean} [options.allowPublic] true to allow public accounts
 * @param {Boolean} [options.allowNoAccount] true to allow page for logged in user, without a specific account?
 * @returns true if restriction not successful
 */
export function enforceRestrictedPage (options) {
  const _options = {
    allowPublic: options?.allowPublic || false,
    allowNoAccount: options?.allowNoAccount || false
  }
  let restrict = true

  const accountData = mAccount.accountData()
  // console.log('enforceRestrictedPage', _options, 'accountData', accountData)

  if (!isUserLoggedIn()) {
    // console.log('enforceRestrictedPage: no user logged in')
    // When no logged in, user should only access isPublic accounts
    if (_options.allowPublic === true && accountData?.isPublic) {
      restrict = false
    } else {
      return returnRestriction()
    }
  } else {
    restrict = false
  }

  // User is logged in: good to go, except if the account itself is restricted: ie no accountData
  // accountData is null if the account is restricted
  if (!accountData) {
    // console.log('enforceRestrictedPage: no account data')
    if (_options.allowNoAccount) {
      restrict = false
    } else {
      return returnRestriction()
    }
  } else {
    restrict = false
  }

  return restrict
}

function returnRestriction () {
  showRestrictedPage()
  return true
}

export const appUser = {
  userData,
  isUserLoggedIn,
  loadUser,
  showRestrictedPage,
  enforceRestrictedPage
}
